import Icon from 'veui/components/Icon'
import { IconLoading } from 'dls-icons-vue'

Icon.register('loading', IconLoading)
